<template>
  <div id="search-body">
    <!-- 头部 -->
    <div class="search-head">
      <a-input-search
        class="search-head-input"
        placeholder="请输入关键词和页面名称"
        @search="onSearch"
        v-model="projectName"
        enterButton="搜索"
        size="large"
      />
    </div>
    <!--导航标签列表 -->
    <div class="search-choose-block">
      <div class="search-choose-content">
        <TagList :tags="tags" @tagFilter="tagFilter" />
        <a-divider dashed />
        <Sort
          @addProject="addProject"
          @editProjects="editProjects"
          :addOrCancel="addOrCancel"
          :editOrDelet="editOrDelet"
          :editStatus="editStatus"
          :curType="curType"
          :sortRule="sortRule"
          @changeCurType="changeCurType"
        />
      </div>
    </div>
    <div class="search-content">
      <ListCard
        :dataList="pageListCards"
        :editStatus="editStatus"
        @selectRadio="selectRadio"
      />
    </div>
    <div class="pagination">
      <a-pagination
        :current="pageList_params.pageNo"
        @change="pageChange"
        size="large"
        :total="list_total"
        :pageSize="pageList_params.pageSize"
        show-quick-jumper
      />
    </div>
    <Modal
      @handleOk="handleOk"
      @handleCancel="handleCancel"
      @save="save"
      @cancel="cancel"
      :tags="tags"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :editData="editData"
    />
  </div>
</template>

<script>
import HmSearchCard from "@/components/HmSearchCard";
import projectApi from "@/request/api-manager/project.js";
import viewProjectTag from "@/request/api-manager/viewProjectTag.js";
import TagList from "@/components/TagList/TagList.vue";
import Sort from "@/views/project/list/sort/Sort.vue";
import Modal from "@/views/project/list/modal/Modal.vue";
import componentsApi from "@/request/api-manager/component.js";
import ListCard from "@/views/component/listCard";
export default {
  name: "search",
  data() {
    return {
      selectProjectIds: [],
      // nameValue: "",
      // addressValue: "",
      // describeValue: "",
      inputVisible: false,
      inputValue: "",
      confirmLoading: false,
      visible: false,
      addOrCancel: "页面添加",
      editOrDelet: "编辑",
      showSelect: false,
      editStatus: false,
      list_params: {
        pageSize: 8,
        pageNo: 1,
        projectStatus: 0,
      },
      list_total: 100,
      cards: [],
      tags: [],
      curType: "createTime",
      sortRule: "asc",
      selectTags: [],
      projectName: "",
      editData: {},
      /////////////
      pageList_params: {
        pageSize: 8,
        pageNo: 1,
        type: 0,
      },
      pageListCards: [],
      colums: "",
    };
  },
  components: {
    HmSearchCard,
    TagList,
    Sort,
    Modal,
    ListCard,
  },
  watch: {
    activeKey(key) {
      console.log(key);
    },
    projectName(value) {
      let self = this;
      self.pageList_params.title = "*" + value + "*";
      console.log(self.pageList_params.title, "监控");
    },
  },
  mounted() {
    let self = this;
    self.tagList();
    console.log(
      JSON.parse(localStorage.getItem("pro__USER_INFO")),
      "1231231223"
    );
    this.getPageList(this.pageList_params);
  },
  methods: {
    tagList() {
      let self = this;
      projectApi.componentTagList({ pageSize: 1000, pageNo: 1, type: 1 }).then((res) => {
        console.log("tag查询", res.result.records);
        res.result.records.forEach((element) => {
          element.disabled = true;
        });
        self.tags = _.take(res.result.records, 10); // _.take获取数组前n个元素
        console.log("self.tags", self.tags);
      });
    },
    onChange(e) {
      console.log(e);
    },
    async save(params) {
      console.log("保存", params);
      this.visible = false;
      let editResult = await this.queryEdit(params);
      console.log(editResult, "修改结果返回");
      if (editResult.success) {
        this.$message.success("修改成功");
        this.editData = {};
        this.addProject();
        return this.viewProjectTagList(this.list_params);
      }
      console.log("修改失败,原因:", editResult);
      return this.$message.error(editResult.message);
    },
    cancel() {
      console.log("取消");
      this.visible = false;
      this.editData = {};
    },
    handleClose(removedTag) {
      const tags = this.tags.filter((tag) => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: "",
      });
    },

    handleCancel() {
      console.log("Clicked cancel button");
      this.visible = false;
    },
    handleOk() {
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },

    selectRadio(data) {
      console.log("selectRadio", data);
      if (!data.showSelect) {
        this.selectProjectIds.push(data.id);
      } else {
        this.selectProjectIds = this.selectProjectIds.filter((id) => {
          return id != data.id;
        });
      }
      data.showSelect = !data.showSelect;
      console.log("this.selectProjectIds", this.selectProjectIds);
    },
    //编辑
    edidProjectDetails(data) {
      this.visible = true;
      this.editData = data;
    },

    deleteProject(data) {
      console.log("删除", data);
      let self = this;
      self.$confirm({
        title: "确认删除",
        content: "是否删除选中项目?",
        onOk: function () {
          console.log("执行删除", data);
          // projectApi.delete({ id: data }).then((res) => {
          //   self.callApi(res);
          // });
        },
      });
    },
    callApi(res) {
      let self = this;
      if (res.success) {
        // self.viewProjectTagList(self.list_params);
        self.$message.success(res.message);
        self.addProject();
      } else {
        self.$message.warning(res.message);
      }
    },
    editProjects() {
      console.log(this.editOrDelet, "this.editOrDelet");
      if (this.editOrDelet == "编辑") {
        this.editStatus = true;
        this.addOrCancel = "取消";
        this.editOrDelet = "删除";
      } else {
        let self = this;
        self.$confirm({
          title: "确认删除",
          content: "是否删除选中项目?",
          onOk: function () {
            console.log("执行删除", self.selectProjectIds);
            // projectApi
            //   .deleteBatch({ ids: self.selectProjectIds.join(",") })
            //   .then((res) => {
            //     self.callApi(res);
            //   });
          },
        });
      }
    },

    viewProjectTagList(params) {
      let self = this;
      console.log("查询视图", params);
      viewProjectTag.list(params, self.curType, self.sortRule).then((res) => {
        if (res.result.total == 0) {
          self.$message.info("暂无此类标签的项目");
        }
        console.log("视图结果", res);
        res.result.records.forEach((element) => {
          element.showSelect = false;
        });
        self.cards = res.result.records;
        console.log("视图结果", self.cards);
      });
    },

    tagFilter(tagId) {
      let self = this;
      self.pageList_params.tagIds = tagId;
      let params = {
        ...self.pageList_params,
        pageSize: 8,
        pageNo: 1,
      };
      self.getPageList(params);
    },
    pageChange(page) {
      let self = this;
      Object.assign(self.pageList_params, { pageNo: page });
      console.log(page, "page", self.pageList_params);
      self.getPageList(self.pageList_params);
    },
    onSearch(value) {
      let self = this;
      let params = {
        ...self.pageList_params,
        pageSize: 8,
        pageNo: 1,
      };
      self.getPageList(params);
    },
    changeEditStatus() {
      this.editStatus = !this.editStatus;
    },
    toDetail() {},
    addProject() {
      if (this.addOrCancel == "取消") {
        this.editStatus = false;
        this.addOrCancel = "项目添加";
        this.editOrDelet = "编辑";
      } else {
        let self = this;
        // self.$router.push({ path: "/add-page", query: { id: this.project.id } });
        // 暂时不知道要添加的页面是属于哪个项目的
      }
    },
    changeCurType(curType) {
      console.log(curType, "curType??");
      let self = this;
      if (self.curType == curType) {
        self.sortRule = self.sortRule == "desc" ? "asc" : "desc";
      } else {
        self.curType = curType;
        self.sortRule = "asc";
      }
      switch (self.curType) {
        case "projectLikeNum":
          self.colums = "likeNum";
          break;
        case "projectName":
          self.colums = "title";
          break;
        default:
          break;
      }
      self.getPageList(self.pageList_params);
      console.log("排序规则", self.sortRule);
    },
    /**
     * @description 修改接口
     * @param {Object} params 修改的数据
     */
    queryEdit(params) {
      // return projectApi.edit(params).then(res=>{
      //   return res
      // }).catch(error=>{ return error })
    },
    /**
     * @description 请求页面列表
     * @param {Object} params - 参数
     */
    getPageList(params) {
      let self = this;
      console.log("请求的参数", params, self.colums, self.sortRule);
      componentsApi.list(params, self.colums, self.sortRule).then((res) => {
        console.log("第一次加载", res);
        res.result.records.forEach((item) => {
          item.showSelect = false;
        });
        self.pageListCards = res.result.records;
        self.list_total = res.result.total;
        // self.pageList_params.pageNo = 1
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>